module.exports = __webpack_public_path__ + "europa.ubezpieczenia-logo.svg?608f25b760fdd3db2394e0fa11b5ae95";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/europa.ubezpieczenia-logo.svg
// module id = 101
// module chunks = 0